import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Link as ScrollLink } from 'react-scroll';

interface NavLinkProps {
  to: string;
  children: React.ReactNode;
  className?: string;
}

export const NavLink: React.FC<NavLinkProps> = ({ to, children, className = '' }) => {
  const location = useLocation();

  if (location.pathname === '/') {
    return (
      <ScrollLink
        to={to}
        spy={true}
        smooth={true}
        offset={-64} // Ajuste selon la hauteur de ton header
        duration={500}
        className={`${className} cursor-pointer`}
      >
        {children}
      </ScrollLink>
    );
  }
  
  return (
    <RouterLink to={`/#${to}`} className={className}>
      {children}
    </RouterLink>
  );
};